import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    url: request.adornUrl('/sys/login'),
    method: 'post',
    data
  })
}

//发送短信验证码
export function SendSms (data) {
  return request({
    url: request.adornUrl('/weChat/sendSms'),
    method: 'POST',
    data
  })
}
